/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns the current user's full name.
 *
 * @agent-skills: tenant-context
 */
export const useUserFullname = (): string | null => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.userFullname;
};
